import React from "react"
import { useTheme } from "@chakra-ui/system"
import { useThresholdsColors } from "../lib/hooks/useThresholdsColors"
import { ZoneEntity } from "../lib/types/zone"
import GeoJSONLayer from "../mapbox/GeoJSONLayer"
import { useFillOpacity } from "../lib/hooks/useDropZoneStyle"

interface BikesMapDropzonesLayerProps {
  dropzone: ZoneEntity
  selectedZone: ZoneEntity | undefined
}

export const BikesMapDropzonesLayer: React.FC<BikesMapDropzonesLayerProps> = ({ dropzone, selectedZone }) => {
  const isSelected = selectedZone?.uuid === dropzone.uuid || false
  const theme = useTheme()
  const polygonsFillOpacity = useFillOpacity()
  const zoneColor =
    useThresholdsColors({
      minThresh: dropzone.low_threshold,
      maxThresh: dropzone.high_threshold,
      val: dropzone.bicycle_count,
    }) ?? theme.colors.blue["500"]

  const { polygon, ...properties } = dropzone

  const multiPolygonFeature = {
    type: "Feature",
    geometry: polygon,
    properties: { ...properties },
  } as GeoJSON.Feature

  return (
    <GeoJSONLayer
      id={dropzone.uuid}
      data={multiPolygonFeature}
      fillPaint={{
        fillColor: zoneColor,
        fillOpacity: polygonsFillOpacity,
      }}
      linePaint={{
        lineWidth: 1,
        lineColor: isSelected ? theme.colors.pink["500"] : theme.colors.blue["800"],
        lineDasharray: isSelected ? [2, 1] : [1],
      }}
    />
  )
}
